import PropTypes from 'prop-types'
import clsx from 'clsx'

/**
 * StatsCard Component
 * Displays KPI metrics with icon, label, value, and trend
 */
export default function StatsCard({
  label,
  value,
  icon: Icon,
  trend,
  color = 'teal',
  loading = false,
}) {
  const colorClasses = {
    teal: 'bg-pawssible-teal-50 text-pawssible-teal-600',
    amber: 'bg-pawssible-amber-50 text-pawssible-amber-600',
    slate: 'bg-pawssible-slate-100 text-pawssible-slate-600',
  }

  const trendColor = trend >= 0 ? 'text-green-600' : 'text-red-600'

  return (
    <div className="card">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-pawssible-slate-600">{label}</p>
          {loading ? (
            <div className="h-8 w-24 bg-pawssible-slate-200 rounded animate-pulse mt-2" />
          ) : (
            <p className="text-3xl font-bold text-pawssible-slate-900 mt-2">{value}</p>
          )}
          {trend !== undefined && (
            <p className={clsx('text-xs font-medium mt-2', trendColor)}>
              {trend >= 0 ? '+' : ''}{trend}% from last month
            </p>
          )}
        </div>
        {Icon && (
          <div className={clsx('p-3 rounded-lg', colorClasses[color])}>
            <Icon size={24} />
          </div>
        )}
      </div>
    </div>
  )
}

StatsCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.elementType,
  trend: PropTypes.number,
  color: PropTypes.oneOf(['teal', 'amber', 'slate']),
  loading: PropTypes.bool,
}
